export const calendarItems=['today','next 7 days','all days']